<!-- 底部 -->
<template>
  <div id='footer'>
    <div class="wrap">
      <img src="/img/logo-footer.png" alt="logo">
      <span class="logo">京ICP备18011062号-1</span>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  components: {},
  created () { },
  methods: {}
}
</script>
<style scoped lang='scss'>
#footer {
  height: 63px;
  line-height: 63px;
  .wrap {
    position: fixed;
    bottom: 0px;
    left: 50%;
    transform: translateX(-50%);
    .logo {
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(136, 141, 157, 1);
      vertical-align: middle;
      transform: translateY(-5px);
      display: inline-block;
      &:before{
        width: 1px;
        height: 24px;
        background:rgba(224,227,231,1);
        display: inline-block;
        content: ' ';
        margin: 0 40px 0 25px;
        transform: translateY(5px);
      }
    }
  }
}
</style>
